export enum DashboardView {
  DASHBOARD = 1,
}
